import React from "react";
import {
  isDraftRequest,
  scheduledPublishDate,
  formatScheduledPublish,
} from "../../utils/tenderFormatters";

/**
 * The one badge that says "this row is not live yet".
 *
 * Until now a club request carried no status marker at all — the only status
 * reading on the card was the keep-alive gate (club/TenderCard.js:508-513) —
 * so a draft would have looked exactly like a published request. This badge is
 * what makes the difference visible, and it sits in the card's existing badge
 * row next to BOOSTED / LITE / NEWEST, in that row's own language: a small
 * tinted pill, no border, uppercase-free label.
 *
 * Two states, never both:
 *   Draft                      neutral, the request is parked
 *   Scheduled · 15 Aug, 09:00  planned, the sweep will publish it then
 *
 * Renders nothing at all for a row that is not a draft, so every call site can
 * mount it unconditionally.
 */
const RequestDraftBadge = ({ tender, className = "" }) => {
  if (!isDraftRequest(tender)) return null;

  const scheduled = scheduledPublishDate(tender);
  const base =
    "px-2 py-0.5 text-[10px] font-semibold rounded-full whitespace-nowrap";

  if (scheduled) {
    return (
      <span
        className={`${base} bg-[#E9F3FF] text-[#2283FF] ${className}`}
        title={`Goes live ${formatScheduledPublish(scheduled)}`}
      >
        Scheduled · {formatScheduledPublish(scheduled)}
      </span>
    );
  }

  return (
    <span className={`${base} bg-[#F1F5F9] text-[#45556C] ${className}`}>
      Draft
    </span>
  );
};

export default RequestDraftBadge;
